import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
// Scoped fonts used by the casting brief redesign
import "@fontsource/dm-serif-display/400.css";
import "@fontsource/fira-sans/400.css";
import "@fontsource/fira-sans/500.css";
import "@fontsource/fira-sans/600.css";
import "@fontsource/instrument-serif/400.css";
import "@fontsource/instrument-serif/400-italic.css";
import "@fontsource/work-sans/400.css";
import "@fontsource/work-sans/500.css";
import "@fontsource/work-sans/600.css";
import "@fontsource/lora/400.css";
import "@fontsource/lora/400-italic.css";
import "@fontsource/lora/600.css";
import "@fontsource/nunito-sans/400.css";
import "@fontsource/nunito-sans/600.css";
import "@fontsource/playfair-display/400.css";
import "@fontsource/playfair-display/400-italic.css";
import "@fontsource/playfair-display/700.css";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/600.css";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { initCrossSubdomainSession } from "./lib/cross-subdomain-session";
import { installGlobalErrorHandlers } from "./lib/install-global-error-handlers";

// Capture async crashes (window.onerror + unhandledrejection) so they reach
// the same backend sink as React ErrorBoundary catches.
installGlobalErrorHandlers();

// Fire-and-forget: hydrate a shared *.focuscasting.com session cookie if any.
// No-op on every other host.
initCrossSubdomainSession();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary scope="root">
    <App />
  </ErrorBoundary>
);

